import React from 'react';
import PropTypes from 'prop-types';
import { Field, FormGroup } from '@availity/form';
import { Button, Col, Label, Row } from 'reactstrap';
import { SelectField } from '@availity/select';

const AwardeeMiscExpense = props => {
  const { 
    index,
    expenseType,
    miscAmount,
    expenseSelected,
    setMiscExpenseType,
    setMiscAmount,
    formatMiscAmount,
    setExpenseType
  } = props;

  return (
    <>
      <Row>
        <Col sm='4'>
          <Field
            type='text'
            name={`miscExpense${index}`}
            className='straighten-borders'
            label='Miscellaneous expense type*'
            onChange={(e) => setMiscExpenseType(e, index)}
            value={expenseType}
            maxLength={50}
          />
        </Col>
        <Col sm='2'>
          <FormGroup className='label-font'>
            <Label htmlFor={`miscAmount${index}`}>
              Amount*
            </Label>
            <div>
              <span className='dollar-sign'>&#36;</span>
              <Field
                type='text'
                name={`miscAmount${index}`}
                aria-label='miscellaneous amount'
                className='straighten-borders right-text'
                onChange={(e) => setMiscAmount(e, index)}
                onBlur={(e) => formatMiscAmount(e, index)}
                value={miscAmount}
                maxLength={6}
              />
            </div>
          </FormGroup>
        </Col>
        <Col sm='3'>
          <FormGroup className='label-font'>
            <Label htmlFor={`miscType${index}`}>
              Expense type*
            </Label>
            <SelectField
              name={`miscType${index}`}
              className='straighten-borders typeDropdown'
              value={expenseSelected}
              onChange={(val) => setExpenseType(val, index)}
              options={
                [
                  {
                    value: '',
                    label: 'Select'
                  },
                  {
                    value: 'One-time expense',
                    label: 'One-time expense'
                  },
                  {
                    value: 'Recurring expense',
                    label: 'Recurring expense'
                  }
                ]
              } 
            />
          </FormGroup>
        </Col>
        {
          index > 0 ?
          <Col className='align-self-center' sm='1'>
            <Button
              close  
              onClick={() => {
                props.removeExpense(index)
              }}
            />
          </Col>
          :
          null
        }
      </Row>
    </>
  )
}

AwardeeMiscExpense.propTypes = {
  index: PropTypes.number,
  expenseType: PropTypes.string,
  miscAmount: PropTypes.string,
  expenseSelected: PropTypes.string,
  setMiscExpenseType: PropTypes.func,
  setMiscAmount: PropTypes.func,
  formatMiscAmount: PropTypes.func,
  removeExpense: PropTypes.func,
  setExpenseType: PropTypes.func
}

export default AwardeeMiscExpense;